export default __webpack_public_path__ + "static/media/orders.5d632350.svg";